import { faFolderPlus, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import { clsx } from 'clsx';
import { useElementObserver } from '@client/new/hooks/useElementObserver';

export const BulkActionMenu = ({
  observedId,
  bulkAction,
}: {
  observedId: string;
  bulkAction: {
    selectedCount: number;
    bulkDelete: () => void;
    moveToFolder: () => void;
  };
}) => {
  const { isVisibleInViewport } = useElementObserver({ observedId });

  if (bulkAction.selectedCount === 0) return null;
  return (
    <div
      className={clsx(
        isVisibleInViewport && 'flex',
        !isVisibleInViewport && 'sticky top-4',
      )}
      style={{ zIndex: 2 }}
    >
      <div className="flex gap-6 bg-white rounded-[10px] shadow-gallery max-w-fit px-4 py-2">
        <div className="flex gap-2.5 items-center">
          <Typography>{bulkAction.selectedCount}</Typography>
          <Typography>selected</Typography>
        </div>
        <Button
          leftIcon={faFolderPlus}
          color="primaryTonal"
          onClick={bulkAction.moveToFolder}
          className="text-[14px]"
          id="bulkMove"
        >
          Move to folder
        </Button>
        <Button
          leftIcon={faTrash}
          variant="text"
          className="text-[#DA0000]"
          onClick={bulkAction.bulkDelete}
          id="bulkDelete"
        >
          Delete
        </Button>
      </div>
    </div>
  );
};
